import "./ContactMePage.scss";
import React from "react";
import EmailMeButton from "../../components/EmailMeButton/EmailMeButton";

const ContactMePage = () => {
  return (
    <div className="contact-me-page">
     
        <h1>Contact Me</h1>
        <h5>PARTNER WITH ME TODAY</h5>
       
          <>
         <h5> I’m available for appointments at the address below:</h5>
          <br />
          <h5>135 Brant Avenue
          <br />
          Brantford, Ontario, N3T 3H5</h5>
          <br />
          <h5>Call me:
          <br /> 
            <a href="tel:2269209764" className="contact-link">
              226.920.9764
            </a></h5>
            <br /> <br />
            <h5>or Email me:
            <br /> 
       <a href="mailto:lindsayadamsdesign@gmail.com" className="contact-link">lindsayadamsdesign@gmail.com</a></h5>
       <br />
       <EmailMeButton
      email="lindsayadamsdesign@gmail.com"
      textColor="#1f2022"
      iconColor="#1f2022"
      />

       </>
          
          
    
    </div>
  );
};

export default ContactMePage;
